<template>
  <div class="start-wrapper" :class="{ dark: isDark }">
    <slot />
  </div>
</template>

<script lang="ts" setup>
const { $versions } = useNuxtApp();

const isDark = computed(() => $versions.value.homePage === '5' || $versions.value.quiz === '7');
</script>

<style lang="scss" scoped>
.start-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;

  &.dark {
    background: $text-color;
  }
}
</style>
